import { SupersetClient } from '@aibi-ui/core';

// 查询看板列表
export const getDashboardListAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/dashboard/',
    searchParams,
  });

// 查询看板是否收藏
export const getDashboardIsFavoritesAPI = searchParams =>
  SupersetClient.get({
    endpoint: '/api/v1/dashboard/favorite_status/',
    searchParams,
  });

// 收藏看板
export const postDashboardFavoriteAPI = id =>
  SupersetClient.post({ endpoint: `/api/v1/dashboard/${id}/favorites/` });

// 取消收藏看板
export const deleteDashboardFavoriteAPI = id =>
  SupersetClient.delete({ endpoint: `/api/v1/dashboard/${id}/favorites/` });

/** 新增看板分享 */
export const postMyDashboardShareAPI = jsonPayload =>
  SupersetClient.post({ endpoint: '/api/v1/my_dashboard/share', jsonPayload });

/** 修改看板分享 */
export const putMyDashboardShareAPI = jsonPayload =>
  SupersetClient.put({ endpoint: '/api/v1/my_dashboard/share', jsonPayload });

/** 查看分享详情 */
export const getMyDashboardShareAPI = shareId =>
  SupersetClient.get({ endpoint: `/api/v1/my_dashboard/share/${shareId}` });

/** 通过看板id查询分享详情 */
export const getMyDashboardShareByDashboardAPI = dashboardId =>
  SupersetClient.get({
    endpoint: `/api/v1/my_dashboard/share/byDashboard/${dashboardId}`,
  });
